import { Choice, Maybe, Site } from "types";

export const mapSitesToChoices = (sites: Maybe<Site[]>): Choice[] => {
  if (!sites) {
    return [];
  }

  return sites.map((site) => ({
    id: site.id,
    name: site.name
  }));
};
